import { render, staticRenderFns } from "./OpenCartDispatch.vue?vue&type=template&id=6c0aae40&"
import script from "./OpenCartDispatch.vue?vue&type=script&lang=js&"
export * from "./OpenCartDispatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "OpenCartDispatch.vue"
export default component.exports